import { useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { loginUser, loginWithGoogle } from "src/store/auth"

import Modal from "src/components/modals/Modal"
import GoogleSignInButton from "src/components/GoogleSignInButton"
import AudioSettings from "src/components/AudioSettings"
import PlayAsGuestButton from "src/components/PlayAsGuestButton"
import { apiErrorLines } from "src/utils/apiErrors"

const LoginModal = ({ onRegister }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [errors, setErrors] = useState([])
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  })
  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(loginUser(formData))
      .unwrap()
      .then(() => ModalService.hideAll())
      .catch(setErrors)
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  // Google's callback fires outside React's event system, so this is the only place the credential
  // exists — hand it straight to the thunk. There is nothing to store and nothing to re-use: the
  // token is single-use and short-lived, and what comes back is one of our own sessions.
  const handleGoogleCredential = (credential) => {
    setErrors([])
    dispatch(loginWithGoogle(credential))
      .unwrap()
      .then(() => ModalService.hideAll())
      .catch(setErrors)
  }

  const onForgetPassword = () => {
    ModalService.show("ForgotPasswordModal")
  }

  return (
    <Modal>
      <h1>{t("auth.loginTitle")}</h1>
      {apiErrorLines(errors).map(({ key, text }) => (
        <p key={key} className="errored-text">
          {text}
        </p>
      ))}
      <form onSubmit={handleSubmit}>
        <label htmlFor="username">{t("auth.usernameLabel")}</label>
        <input
          type="text"
          id="username"
          name="username"
          className="form-input"
          placeholder={t("auth.usernamePlaceholder")}
          value={formData.username}
          onChange={handleInputChange}
          required
        />

        <label htmlFor="password">{t("auth.passwordLabel")}</label>
        <input
          type="password"
          id="password"
          name="password"
          className="form-input"
          placeholder={t("auth.passwordPlaceholder")}
          value={formData.password}
          onChange={handleInputChange}
          required
        />

        <div className="modal-actions">
          <button type="submit">{t("auth.loginButton")}</button>
          <button type="button" className="quiet" onClick={onRegister}>
            {t("auth.noAccount")}
          </button>
        </div>

        <button type="button" className="modal-link" onClick={onForgetPassword}>
          {t("auth.forgotPassword")}
        </button>
      </form>

      <GoogleSignInButton onCredential={handleGoogleCredential} text="signin_with" />

      {/* No email, no password: a funny name and straight in (owner, 2026-10-02). */}
      <PlayAsGuestButton />

      {/* The menu music is already playing while this form is open, and Settings lives
          behind the account being created (Q18) — so the volume comes to the form. */}
      <AudioSettings />
    </Modal>
  )
}

export default LoginModal
